export default "__VITE_ASSET__CvJqqm6e__"